import { configureStore } from '@reduxjs/toolkit'
import countSliceReducer from './slices/countSlice';
import adminToogleReducer from './slices/adminToogle';
import userTypeReducer from './slices/userTypeSlice';
import currentUserReducer from './slices/currentUserSlice';
import currentPurchasereducer from './slices/currentPurchase';
import hierarchiesReducer from './slices/hierarchiesSlice';
import brandsReducer from './slices/brandsSlice';
import transactionsReducer from './slices/transactionsSlice';
import personalInfoReducer from './slices/personalInfoSlice';
import registrationHierarchiesReducer from './slices/registrationHierarchiesSlice';
import locationDataReducer from './slices/locationDataSlice';
import tierPerformanceReducer from './slices/tierPerformanceSlice';
import detailedPointsReducer from './slices/detailedPointsSlice';
import userPointsReducer from './slices/userPointsSlice';
const store = configureStore({
    reducer: {
        countSlice : countSliceReducer,
        adminToogle : adminToogleReducer,
        userTypeSlice: userTypeReducer,
        currentUser: currentUserReducer,
        currentPurchase: currentPurchasereducer,
        hierarchies: hierarchiesReducer,
        brands: brandsReducer,
        transactions: transactionsReducer,
        personalInfo: personalInfoReducer,
        registrationHierarchies: registrationHierarchiesReducer,
        locationData: locationDataReducer,
        tierPerformance: tierPerformanceReducer,
        detailedPoints: detailedPointsReducer,
        userPoints: userPointsReducer
    },
    
  });
  
  export default store;

